import * as ff from 'ff-canvas';
import { createDOMCanvas, Device, Pipeline, Transform } from 'ff-canvas';
import { reportError } from '@gift/common/helpers/logging';
import { loadImage } from '@gift/common/helpers/loadImage';
import { loadShape } from '@gift/common/helpers/loadShape';
import { loadSvg } from '@gift/common/helpers/loadSvg';

type Options = {
    requestRender: () => void,
    transform: Transform,
    useDevicePixelRatio: boolean
};

export const createPipeline = (canvas: HTMLCanvasElement, options: Options): Pipeline => {

    const device = options.useDevicePixelRatio
        ? Device.browser(options.transform)
        : new Device(createDOMCanvas, 1, options.transform);

    const pipeline = new Pipeline(
        canvas, device,
        options.requestRender,
        e => reportError(e));

    if (options.useDevicePixelRatio) {
        pipeline.applyPixelRatio();
    }

    addPaintersTo(pipeline);

    return pipeline;
};

const addPaintersTo = (pipeline: Pipeline): void => {

    const placeholder = new Image();
    placeholder.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';

    const painters = [
        new ff.TextPainter(),
        new ff.RectanglePainter(),
        new ff.CirclePainter(),
        new ff.TrianglePainter(),
        new ff.QrCodePainter(),
        new ff.CustomShapePainter(),
        new ff.ClipartPainter(loadImage, () => placeholder),
        new ff.PatternPainter(loadImage, () => placeholder),
        new ff.LoadableShapePainter(loadShape),
        new ff.SvgPainter(loadSvg, loadImage, () => placeholder)
    ];

    for (const painter of painters) {
        pipeline.use(painter);
    }
};